import { useState } from 'react';
import { X } from 'lucide-react';
import { Tooltip } from '@mui/material';
import { DataContractDetails } from './DataContractDetails';

export const DataContractDetailsModal = ({
  isOpen,
  onClose,
  contract
}) => {
  const [copiedId, setCopiedId] = useState(null);

  if (!isOpen || !contract) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleCopyLink = async (event) => {
    // prevent row click
    if (event && typeof event.stopPropagation === "function") event.stopPropagation();

    try {
      const linkToCopy = `${window.location.origin}/data-traffic-lights?viewProduct=${contract.name}`;

      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(linkToCopy);
      } else {
        // fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = linkToCopy;
        textarea.setAttribute("readonly", "");
        textarea.style.position = "absolute";
        textarea.style.left = "-9999px";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }

      setCopiedId(contract.name);
      setTimeout(() => setCopiedId(null), 2000);
    } catch (error) {
      console.error("Failed to copy link", error);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-2  z-[99999999]"
      onClick={handleBackdropClick}
    >
      <div className='relative'>
        <div className="bg-white z-999999 rounded-2xl shadow-2xl max-w-7xl w-[90vw] max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className=" relative flex items-center justify-between p-4 border-b border-gray-200">
            <div className="flex items-center gap-4">
              <div className="flex items-center gap-2">
                <h2 className="text-2xl font-bold text-gray-900">
                  {contract.name}
                </h2>
                <Tooltip
                  title={
                    copiedId === contract.name ? "Copied" : "Copy direct link"
                  }
                  arrow
                  placement="right"
                  disablePortal
                  PopperProps={{
                    sx: { zIndex: 100000000 }, // higher than modal
                  }}
                >
                  <span className="inline-flex">
                    <button
                      onClick={handleCopyLink}
                      style={{
                        fontSize: "12px",
                        textTransform: "none",
                        borderRadius: 1,
                        whiteSpace: "nowrap",
                        display: "inline-flex",
                        gap: 1,
                        backgroundColor: "#1D7285",
                        color: "white",
                        padding: "5px",
                        borderRadius: "3px",
                      }}
                    >
                      Copy Link
                    </button>
                  </span>
                </Tooltip>
              </div>
            </div>
            <button
              onClick={onClose}
              className=" absolute right-6 top-4 p-2   transition-colors"
            >
              <X className=" h-[30px] w-[30px] text-gray-500 hover:text-white hover:bg-[#7dc1a9] p-[5px] rounded-lg  " />
            </button>
          </div>
          {/* Content */}
          <DataContractDetails contract={contract} />
        </div>
      </div>
    </div>
  );
};